<template>
  <div>
    <modal
      size="small"
      :hideCloseButton="true"
      v-if="visible && !criado"
      @close-modal=""
    >
      <div slot="header" class="header">Sua Empresa</div>
      <div class="container" slot="content">
        <div class="header">
          <p>
            Preencha esse formulário com informações sobre sua empresa para
            continuar.
          </p>
        </div>
        <form class="content" id="form-token" v-on:submit.prevent="onSubmit">
          <div class="form-box form-creditos">
            <label class="label">Empresa</label>
            <input
              class="field name-w"
              maxlength="40"
              type="text"
              name="nome"
              required="required"
              v-model="form.empresa"
            />
          </div>
          <div class="form-box form-creditos">
            <label class="label">Cargo</label>
            <input
              class="field name-w"
              maxlength="40"
              type="text"
              name="nome"
              required="required"
              v-model="form.cargo"
            />
          </div>
          <div class="form-box form-creditos">
            <label class="label">Telefone</label>
            <vue-country-code
              @onSelect="onSelect"
              :enabledCountryCode="true"
              :preferredCountries="['BR', 'US', 'CA', 'GB']"
              class="country-select"
            >
            </vue-country-code>
            <the-mask
              required="required"
              v-model="form.telefone"
              :mask="
                form.codigoPais === '55'
                  ? ['(##) #####-####']
                  : ['###############']
              "
              :masked="true"
              class="field phone-w"
            />
          </div>
          <div class="form-box form-creditos">
            <label class="label">Segmento de mercado</label>
            <select
              v-model="form.segmentoMercado"
              id="tipo"
              class="form-control"
            >
              <option value="" selected disabled>Selecione uma opção</option>
              <option value="Agronegócio">Agronegócio</option>
              <option value="Análise de Risco/Gestão de Risco">
                Análise de Risco/Gestão de Risco
              </option>
              <option value="Auditoria/Consultoria">
                Auditoria/Consultoria
              </option>
              <option value="Crédito">Crédito</option>
              <option value="Compliance">Compliance</option>
              <option value="Comércio Varejista">Comércio Varejista</option>
              <option value="Comércio (outros)">Comércio (outros)</option>
              <option value="Financeiro">Financeiro</option>
              <option value="Indústria">Indústria</option>
              <option value="Jurídico">Jurídico</option>
              <option value="Logística/Transporte">Logística/Transporte</option>
              <option value="RH">RH</option>
              <option value="Seguro">Seguro</option>
              <option value="Tecnologia">Tecnologia</option>
              <option value="Outro">Outro</option>
            </select>
          </div>
          <div class="form-box form-creditos">
            <label class="label">Quantidade de funcionários</label>
            <select
              v-model="form.quantidadeFuncionarios"
              id="tipo"
              class="form-control"
            >
              <option value="" class="select-placeholder" selected disabled>
                Selecione uma opção
              </option>
              <option value="1 a 9 funcionários">1 a 9 funcionários</option>
              <option value="10 a 49 funcionários">10 a 49 funcionários</option>
              <option value="50 a 99 funcionários">50 a 99 funcionários</option>
              <option value="100 a 200 funcionários">
                100 a 200 funcionários
              </option>
              <option value="Acima de 200 funcionários">
                Acima de 200 funcionários
              </option>
            </select>
          </div>
          <div class="form-box form-creditos">
            <label class="label">Como conheceu o Escavador?</label>
            <select
              v-model="form.comoConheceuEscavador"
              id="tipo"
              class="form-control"
            >
              <option value="" selected disabled>Selecione uma opção</option>
              <option value="Indicação">Indicação</option>
              <option value="Facebook">Facebook</option>
              <option value="Google">Google</option>
              <option value="LinkedIn">LinkedIn</option>
              <option value="Instagram">Instagram</option>
              <option value="Notícias">Notícias</option>
              <option value="Eventos">Eventos</option>
              <option value="Blog">Blog</option>
              <option value="E-mail">E-mail</option>
              <option value="Outro">Outro</option>
            </select>
          </div>
          <div
            v-if="form.comoConheceuEscavador === 'Outro'"
            class="form-box form-creditos"
          >
            <label class="label">Informe o canal por onde conheceu</label>
            <input
              class="form-control canal-w"
              type="text"
              name="comoConheceuEscavadorOutro"
              v-model="form.comoConheceuEscavadorOutro"
            />
          </div>
          <div
            class="form-box form-creditos"
          >
            <label class="label">Como quer utilizar o Escavador</label>
            <text-field
              class="form-control"
              style="width: 80%"
              name="comoQuerUtilizar"
              rows="3"
              v-model="form.comoQuerUtilizar"
            />
          </div>
        </form>
        <div class="header">
          <button class="mt btn" @click.prevent="onSubmit">
            <b>Enviar Formulário</b>
          </button>
        </div>
      </div>
      <div slot="footer"></div>
    </modal>
    <Loading></Loading>
  </div>
</template>

<script>
import Loading from "../monitoramentos/Loading";
import TextField from "../_www/TextField/TextField.vue";
import { isBusinessEmail } from "../../utils/email";
import { subdomainUrl } from "../../utils/url";

export default {
  name: "empresa-form-modal",
  props: ["visible", "usuario"],
  data() {
    return {
      criado: false,
      form: new Form({
        codigoPais: "",
        telefone: "",
        empresa: "",
        cargo: "",
        segmentoMercado: "",
        quantidadeFuncionarios: "",
        comoConheceuEscavador: "",
        comoConheceuEscavadorOutro: "",
        comoQuerUtilizar: "",
      }),
      closeButton: false,
      submited: false,
    };
  },
  components: {
    TextField,
    Loading,
  },
  computed: {
    userHasABusinessEmail() {
      return isBusinessEmail(this.usuario.email)
    },
  },
  methods: {
    onSelect({ name, iso2, dialCode }) {
      this.form.codigoPais = dialCode;
    },
    onSubmit: function () {
      if (!this.userHasABusinessEmail) {
        this.$store.dispatch("showLoadingMessage", {
          message: `<div class="error-message"><p class="error-message_title">Seu cadastro não possui um e-mail corporativo</p> <p class="error-message_description">Faça <a href="${subdomainUrl('www', '/logout')}">logout</a> e entre com o e-mail corporativo da sua empresa ou altere seu e-mail nas <a href="${subdomainUrl('www', '/configuracoes/emails')}">configurações conta</a>.</p></div>`,
          type: "danger",
          timeout: 10000,
        });
        return;
      }

      EventBus.$emit("loading-show");
      let codigoPais = this.form.codigoPais;
      let telefoneArea = "";
      let telefone = this.form.telefone;
      if (codigoPais === "55") {
        telefoneArea = this.form.telefone.slice(1, 3);
        telefone = this.form.telefone.slice(4).trim();
      }
      this.submited = true;

      axios({
        method: "post",
        url: "api/v1/usuario/cadastrar-empresa",
        data: {
          telefoneNumero: telefone,
          telefoneArea: telefoneArea,
          codigoPais: codigoPais,
          empresa: this.form.empresa,
          cargo: this.form.cargo,
          segmentoMercado: this.form.segmentoMercado,
          quantidadeFuncionarios: this.form.quantidadeFuncionarios,
          comoConheceuEscavador: this.form.comoConheceuEscavador,
          comoConheceuEscavadorOutro: this.form.comoConheceuEscavadorOutro,
          comoQuerUtilizar: this.form.comoQuerUtilizar,
        },
      })
        .then((response) => {
          EventBus.$emit("loading-hide");
          this.$store.dispatch("showLoadingMessage", {
            message: "Suas informações foram atualizadas!",
            type: "done",
          });
          this.criado = true;
        })
        .catch((error) => {
          this.submited = false;

          EventBus.$emit("loading-hide");

          this.$store.dispatch("showHttpErrorMessage", {
            httpStatus: error.response.status,
            responseData: error.response.data,
          });
        });
    },
  },
};
</script>
<style lang="stylus" scoped>
.mt
  margin-top 24px
.display-btn
  width 18%
.name-w
  width: 80%
.phone-w
  width: 60%
.country-select
  min-height: 38px
  padding: 0 8px
  border: 1px solid #e0e0e0
  border-radius: 4px
  outline: 0
  background-color: #fff
  font-size: 14px
  font-size: 0.875rem
  line-height: 1.71428571
.header
  text-align center
.form-creditos .label
  color #000
.content
  margin-left 30px
.canal-w
  width: 50%
</style>

<style>
.error-message {
  padding: 16px;
  max-width: 540px;
}
.error-message_title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0;
}
.error-message_description {
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 0;
}
.error-message_description a {
  color: #fff;
  text-decoration: underline;
}
</style>
